<template>
    <td :class="classes"
        ref="cell"
        @mouseenter="handleShowPopper"
        @mouseleave="handleClosePopper">
        <template v-if="renderType === 'index'"><span>{{ column.indexMethod ? column.indexMethod(row) : (naturalIndex + 1) }}</span></template>
        <template v-if="renderType === 'selection'">
            <Checkbox :value="checked"
                @click.native.stop="handleClick"
                @on-change="toggleSelect"
                :disabled="disabled"></Checkbox>
        </template>
        <template v-if="renderType === 'html'"><span v-html="row[column.key]"></span></template>
        <template v-if="renderType === 'normal'">
            <!-- 省略号效果 -->
            <div v-if="column.tooltip || column.ellipsis"
                :class="this.prefixCls + '-cell-ellipsis'"
                :style="{ width: columnWidth ? (columnWidth - 18 * 2) + 'px' : '100%'}">
                <span ref="content"
                data-cls="cell-content">{{ row[column.key] }}</span>
            </div>
            <span v-else>{{ row[column.key] }}</span>
        </template>
        <template v-if="renderType === 'expand' && !row._disableExpand">
            <div :class="expandCls"
                @click="toggleExpand">
                <Icon type="ios-arrow-forward"></Icon>
            </div>
        </template>
        <table-expand v-if="renderType === 'render'"
            :row="sourceData"
            :column="column"
            :index="index"
            :editing="editing"
            :cellEditing="cellEditing"
            :cellEditable="cellEditable"
            :render="column.render"></table-expand>
        <table-slot v-if="renderType === 'slot'"
            :row="sourceData"
            :column="column"
            :index="index"
            :editing="editing"
            :cellEditable="cellEditable"
            :cellEditing="cellEditing"></table-slot>
        <table-edit v-if="renderType === 'edit'"
            :row="sourceData"
            :column="column"
            :index="index"
            :cellEditable="cellEditable"
            :cellEditing="cellEditing">
        </table-edit>
    </td>
</template>
<script>
import TableExpand from './expand';
import TableSlot from './slot';
import TableEdit from './edit';
import Icon from '../icon/icon.vue';
import Checkbox from '../checkbox/checkbox.vue';
import Tooltip from '../tooltip/tooltip.vue';
import AsyncValidator from 'async-validator';
import { getTextWidth } from '../../utils/assist';

var uid = 0
var cellPadding = void(0)

export default {
    name: 'TableCell',

    provide() {
        return { cell: this }
    },

    components: { Icon, Checkbox, TableExpand, TableSlot, TableEdit, Tooltip },

    inject: ['tableRoot'],

    props: {
        prefixCls: String,
        row: Object,
        column: Object,
        columnWidth: [Number, String], // 列宽
        naturalIndex: Number, // index of rebuildData
        index: Number, // _index of data
        rowState: Object,
        fixed: {
            type: [Boolean, String],
            default: false
        },
        sourceData: Object,
        validation: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            renderType: '',
            uid: uid++,
            context: this.$parent.$parent.$parent.currentContext,
        }
    },

    computed: {
        classes() {
            var column = this.column,
                row = this.sourceData

            let cellClassName = ''
            // custom-cell-class
            if (row.cellClassName && column.key && row.cellClassName[column.key]) {
                cellClassName = row.cellClassName[column.key]
            }

            return [
                `${this.prefixCls}-cell`,

                {
                    [`${cellClassName}`]: cellClassName, // cell className
                    [`${column.className}`]: column.className, // column className
                    [`${this.prefixCls}-column-${column.align}`]: column.align,
                    [`${this.prefixCls}-hidden`]: (this.fixed === 'left' && column.fixed !== 'left') ||
                        (this.fixed === 'right' && column.fixed !== 'right') ||
                        (!this.fixed && column.fixed && (column.fixed === 'left' || column.fixed === 'right')),
                    [`${this.prefixCls}-cell-ellipsis`]: this.column.ellipsis || this.column.tooltip || false,
                    [`${this.prefixCls}-cell-with-expand`]: this.renderType === 'expand',
                    [`${this.prefixCls}-cell-with-selection`]: this.renderType === 'selection',
                    [`${this.prefixCls}-cell-with-error`]: this.errors.length > 0,
                    [`${this.prefixCls}-cell-in-readonly`]: !this.cellEditing,
                }
            ];
        },
        expandCls() {
            return [
                `${this.prefixCls}-cell-expand`,
                {
                    [`${this.prefixCls}-cell-expand-expanded`]: this.expanded
                }
            ];
        },
        showErrorTip() {
            return this.errors.length > 0
        },
        errors() {
            return this.validation.errors || []
        },
        errorMsg() {
            return this.errors.map(v => v.message).join(";")
        },
        checked() {
            return this.rowState._isChecked
        },
        disabled() {
            return this.rowState._isDisabled
        },
        expanded() {
            return this.rowState._isExpanded
        },
        // 行是否处于编辑状态
        editing() {
            return this.rowState._isEditing
        },
        canEdit(){
            var canEdit = this.column.canEdit
            
            // 默认为只读
            if (typeof canEdit == "undefined") {
                // 自定义单元格默认可编辑
                return !!this.column.render || !!this.column.slot || !!this.column.edit
            }

            if (typeof canEdit == "function") {
                return canEdit({
                    row: this.sourceData,
                    column: this.column,
                    index: this.index,
                    value: this.sourceData[this.column.key],
                })
            }
        },
        // 单元格是否处于编辑状态
        cellEditing() {
            return !!(this.editing && this.canEdit)
        },
        cellEditable(){
            return !!(this.rowState._isHover && this.canEdit && !this.editing)
        }
    },

    methods: {
        toggleSelect() {
            this.$parent.$parent.$parent.toggleSelect(this.index);
        },
        toggleExpand() {
            this.$parent.$parent.$parent.toggleExpand(this.index);
        },
        handleClick() {
            // 放置 Checkbox 冒泡
        },
        editCellChange(key, val) {
            // 更新数据
            this.tableRoot.updateCurrentRow(this.index, {
                [key]: val
            })
        },
        handleShowPopper() {
            var $cell = this.$refs.cell
            // 错误提示框优先显示
            if (this.showErrorTip) {
                return this.tableRoot.handleShowPopper({
                    reference: $cell, 
                    content: this.errorMsg,
                    width: getTextWidth(this.errorMsg, 12) + 24
                })
            }

            // 文本溢出tooltip
            if(this.column.tooltip){
                const $content = $cell.querySelector("[data-cls=cell-content]")

                if($content && $content.offsetWidth > ($cell.clientWidth - cellPadding * 2)){
                    var text = this.row[this.column.key]

                    return this.tableRoot.handleShowPopper({
                        reference: $cell,
                        content: text,
                        width: getTextWidth(text, 12) + 24
                    })
                }
            }
        },
        handleClosePopper() {
            this.tableRoot.handleClosePopper()
        },
    },

    created() {
        if (this.column.type === 'index') {
            this.renderType = 'index';
        } else if (this.column.type === 'selection') {
            this.renderType = 'selection';
        } else if (this.column.type === 'html') {
            this.renderType = 'html';
        } else if (this.column.type === 'expand') {
            this.renderType = 'expand';
        } else if (this.column.render) {
            this.renderType = 'render';
        } else if (this.column.slot) {
            this.renderType = 'slot';
        } else if (this.column.edit) {
            this.renderType = 'edit';
        } else {
            this.renderType = 'normal';
        }
    },

    mounted(){
        // 获取cell padding
        if(cellPadding == void(0)){
            cellPadding = parseFloat(window.getComputedStyle(this.$refs.cell).paddingLeft) || 0
        }
    }
};
</script>